import { Base } from '@studiometa/js-toolkit';

/**
 * LookingFor.
 * @augments {Base}
 */
export default class LookingFor extends Base {
  /**
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'LookingFor',
    refs: ['form'],
  };

  /**
   *
   */
  mounted() {
    this.bindEvents();
  }

  /**
   * Bind form events
   */
  bindEvents() {
    const form = Array.isArray(this.$refs.form) ? this.$refs.form[0] : this.$refs.form;
    if (form) {
      form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  /**
   * Handle form submission
   * @param {Event} event
   */
  handleSubmit(event) {
    event.preventDefault();

    const form = Array.isArray(this.$refs.form) ? this.$refs.form[0] : this.$refs.form;
    const selectedOption = form.querySelector('input[name="looking-for-option"]:checked');

    if (selectedOption) {
      const url = selectedOption.dataset.url;
      if (url) {
        window.location.href = url;
      }
    }
  }
}
